module.exports = __webpack_public_path__ + "img/Ireland.0dcabb25.png";